const getLength = value => value.length;
export default getLength;



// WEBPACK FOOTER //
// ./src/lib/helpers/PDFHelpers/getLength.js